module.exports = __webpack_public_path__ + "static/media/profile-user.4a2156be.svg";